import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import classNames from "classnames";

import { AscBadgeColor } from "@ascendnow/shared";
import { AscFinalCard, useResponsive } from "@ascendnow/ascend-components";

import AscCircularProgressBarWithIcon from "../AscCircularProgressBarWithIcon/AscCircularProgressBarWithIcon";
import AscTrackProgressCard from "../AscCards/AscTrackProgressCard/AscTrackProgressCard";
import styles from "./AscTrackProgressBarWithBoxes.module.scss";

export interface AscTrackProgressBarWithBoxesProps {
  steps: {
    stage: {
      id: string;
      name: string;
      badgeColor: string;
      modulesNum: number;
    };
    id: string;
    isPassed?: boolean;
    isOpen?: boolean;
    passedModulesPercentage: number;
    passedModules: number;
    modulesCount: number;
    gradeScore: number;
  }[];
  onClick: (id: string) => void;
  stages?: any;
  type: "entrepreneurship" | "internship";
  urlJob: string;
  url: string;
  totalStages: number;
  currentPage: number;
  color: AscBadgeColor;
  className?: string;
}

function AscTrackProgressBarWithBoxes({
  steps,
  color,
  type,
  urlJob,
  url,
  totalStages,
  currentPage,
  onClick,
  className,
}: AscTrackProgressBarWithBoxesProps) {
  const [currentStep, setCurrentStep] = useState<number>();
  const router = useRouter();
  const firstLocked = steps?.[0]?.isOpen;
  const lastLocked = steps?.[steps?.length - 1]?.isOpen;
  const lengthOfAscTrackProgressCard = steps?.filter(
    (step) => step?.stage
  )?.length;

  useEffect(() => {
    const max = steps?.length - 1;
    const value = steps?.findIndex((el) => !el?.isOpen) - 1;

    if (value > max) {
      setCurrentStep(100);
      return;
    }
    if (value < 0 && steps?.[value]?.isOpen) {
      setCurrentStep(100);
      return;
    }

    const percentage = (value * 100) / (max || 1);
    setCurrentStep(percentage);
  }, [steps]);

  const navigatehandler = () => {
    if (type === "internship") {
      router.push(urlJob);
    } else {
      router.push(url);
    }
  };
  return (
    <div
      className={classNames(
        styles.container,
        {
          [styles.teal]: color === "TEAL",
          [styles.pink]: color === "PINK",
          [styles.purple]: color === "PURPLE",
          [styles.green]: color === "GREEN",
          [styles.orange]: color === "ORANGE",
        },
        className,
        {
          [styles.marginAuto]:
            lengthOfAscTrackProgressCard < 4 && currentPage !== totalStages,
          [styles.marginFinal]:
            lengthOfAscTrackProgressCard > 2 && currentPage === totalStages,
          [styles.marginAutoFinal]:
            lengthOfAscTrackProgressCard < 3 && currentPage === totalStages,
        }
      )}
    >
      <div className={styles.progressBarWrapper}>
        <div
          style={
            {
              "--completionPercent": `${currentStep}%`,
            } as React.CSSProperties
          }
          className={classNames(styles.progressBar, {
            [styles.beforeUnlocked]: !firstLocked,
            [styles.afterUnlocked]: !lastLocked,
          })}
        ></div>
      </div>
      {steps && Array.isArray(steps) && steps?.length > 0 && (
        <div className={styles.stepsContainer}>
          {steps?.map((step) => (
            <div key={step.id} className={styles.step}>
              <AscCircularProgressBarWithIcon
                id={step?.id}
                color={color}
                percentage={step?.passedModulesPercentage}
                locked={!step?.isOpen}
                number={step?.stage?.modulesNum}
              />
              <div
                className={styles.cardWrapper}
                onClick={
                  step?.isOpen ? () => onClick(step?.stage?.id) : undefined
                }
              >
                <AscTrackProgressCard
                  title={step?.stage?.name}
                  grade={step?.gradeScore || 0}
                  color={color}
                  completedModules={step?.passedModules}
                  totalModules={step?.modulesCount}
                  locked={!step?.isOpen}
                  className={styles.trackProgressCard}
                />
              </div>
            </div>
          ))}
        </div>
      )}

      {currentPage === totalStages && (
        <div className={styles.finalWrapperContainer}>
          <AscFinalCard onClick={navigatehandler} type={type} />
        </div>
      )}
    </div>
  );
}

export default AscTrackProgressBarWithBoxes;
